import { ReactRenderer } from "@knowt/editor/react";
import { Editor, Range } from "@knowt/editor/core";
import { SuggestionKeyDownProps, SuggestionProps } from "@tiptap/suggestion";
import { EditorState } from "@knowt/editor/pm/state";
import EmojiList from "./components/EmojiList";
import { createPortal } from "react-dom";

export const emojiSuggestion = {
    items: ({ editor, query }: { editor: Editor; query: string }) =>
        editor.storage.emoji.emojis
            .filter(
                ({ shortcodes, tags }: { shortcodes: string[]; tags: string[] }) =>
                    shortcodes.find(shortcode => shortcode.startsWith(query.toLowerCase())) ||
                    tags.find(tag => tag.startsWith(query.toLowerCase()))
            )
            .slice(0, 250),

    allowSpaces: false,

    // make sure to only display emoji picker when ` :` is typed
    // `</p>:` should not work
    // `</strong>:` should not work
    // ` :` only this must work
    allow: (props: { editor: Editor; state: EditorState; range: Range; isActive?: boolean }) => {
        const { selection } = props.state;
        const { $from } = selection;
        const node = $from.parent;
        const isNodeEmpty = node.textContent === ":";

        const indexOfColon = props.range.from;
        const char = props.state.doc.textBetween(indexOfColon - 1, indexOfColon);
        const isLeadingSpace = char === " ";

        return isNodeEmpty ? true : isLeadingSpace;
    },

    render: () => {
        let component;

        return {
            onStart: (props: SuggestionProps<any>) => {
                component = new ReactRenderer(EmojiList, { props, editor: props.editor });
                createPortal(component.element, document.body);
            },

            onUpdate(props: SuggestionProps<any>) {
                component.updateProps(props);
            },

            onKeyDown(props: SuggestionKeyDownProps) {
                if (props.event.key === "Escape") {
                    component.destroy();

                    return true;
                }

                return component.ref?.onKeyDown(props);
            },

            onExit() {
                component.destroy();
            },
        };
    },
};

export default emojiSuggestion;
